module.exports = __webpack_public_path__ + "img/howtop2-100.46074814.jpg";